import { render, staticRenderFns } from "./ManualCostTable.vue?vue&type=template&id=0844cda6&scoped=true"
import script from "./ManualCostTable.vue?vue&type=script&lang=js"
export * from "./ManualCostTable.vue?vue&type=script&lang=js"
import style0 from "./ManualCostTable.vue?vue&type=style&index=0&id=0844cda6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0844cda6",
  null
  
)

export default component.exports